import type { UseOrganizationPixelMetricsFetch } from '@openx/components-organization/lib/utils/context/OrganizationHookTypes.ts';
import { ReactQueryStaleTime } from '@openx/constants/react-query.ts';
import type { OrganizationPixelMetricData } from '@openx/types/organization.ts';
import { QueryKeys } from '@openx/utils/api/queryKeys.ts';
import { useQuery } from '@tanstack/react-query';
import { GetPixelMetricsDocument } from '../../../graphql/query/organizations/GetPixelMetrics.generated.tsx';
import { getGraphQLRequestFromClient } from '../../../modules/graphql/types.ts';

const toPixelMetric = (row: {
  event_type: string;
  event_type_label: string;
  fires_30d?: unknown;
  unique_30d?: unknown;
  last_fire_at?: string | null;
}): OrganizationPixelMetricData => ({
  event_type: row.event_type,
  event_type_label: row.event_type_label,
  fires_30d: row.fires_30d != null ? Number(row.fires_30d) : null,
  unique_30d: row.unique_30d != null ? Number(row.unique_30d) : null,
  last_fire_at: row.last_fire_at ?? null,
});

export const useOrganizationPixelMetricsFetch: UseOrganizationPixelMetricsFetch = accountId => {
  const { data, error, isLoading } = useQuery({
    enabled: !!accountId,
    queryFn: ({ client }) =>
      getGraphQLRequestFromClient(client)(GetPixelMetricsDocument, { accountId: accountId ?? '' }),
    queryKey: [QueryKeys.PIXEL_METRICS, accountId],
    staleTime: ReactQueryStaleTime.MINUTES_15,
    retry: false,
  });

  return {
    pixelMetrics: (data?.pixel_event_metrics ?? []).map(toPixelMetric),
    error: error ?? undefined,
    loading: isLoading,
  };
};
